import React from 'react'
import './Commentary.scss'
import oversToBalls from '../util/oversToBalls'

export default function Commentary({ teams, scoregrid, commentary, displayInnings, isHundred }) {
    if (! commentary) {
        return (
            <div className="commentaries">
                Innings yet to start
            </div>
        )
    }

    if (! teams) {
        return (
            <div className="commentaries">
                Waiting for teams data
            </div>
        )
    }

    const { commentaries: commentaryData } = commentary;
    const { overs } = scoregrid;

    let { inns1, inns2, inns3, inns4 } = commentaryData;

    let { inns1: scoregrid_inns1, inns2: scoregrid_inns2, inns3: scoregrid_inns3, inns4: scoregrid_inns4 } = overs;

    let commentaries = []

    switch (displayInnings) {
        case 1:
            if (inns1) {
                commentaries = [ ...inns1];
            }
            break;
        case 2:
            if (inns2) {
                commentaries = [ ...inns2];
            }
            break;
        case 3:
            if (inns3) {
                commentaries = [ ...inns3];
            }
            break;
        case 4:
            if (inns4) {
                commentaries = [ ...inns4];
            }
            break;
        default:
            return (
                <div className="commentaries">
                    Innings yet to start
                </div>
            );
    }

    // Most recent commentary is displayed first
    commentaries.reverse();

    let displayCommentaries = []

    commentaries.forEach(c => {
        const over = String(Math.trunc(c.ball) + 1);

        // Fetch values from the scoregrid for over summary
        let runs = '';
        let wickets = '';
        let total = '';
        if (displayInnings === 1) {
            if (scoregrid_inns1) {
                const thisOver = scoregrid_inns1.find(o => o.ov === over)
                if (thisOver) {
                    runs = thisOver.runs;
                    wickets = thisOver.wkts;
                    total = thisOver.total;
                }
            }
        } else if (displayInnings === 2) {
            if (scoregrid_inns2) {
                const thisOver = scoregrid_inns2.find(o => o.ov === over)
                if (thisOver) {
                    runs = thisOver.runs;
                    wickets = thisOver.wkts;
                    total = thisOver.total;
                }
            }
        } else if (displayInnings === 3) {
            if (scoregrid_inns3) {
                const thisOver = scoregrid_inns3.find(o => o.ov === over)
                if (thisOver) {
                    runs = thisOver.runs;
                    wickets = thisOver.wkts;
                    total = thisOver.total;
                }
            }
        } else if (displayInnings === 4) {
            if (scoregrid_inns4) {
                const thisOver = scoregrid_inns4.find(o => o.ov === over)
                if (thisOver) {
                    runs = thisOver.runs;
                    wickets = thisOver.wkts;
                    total = thisOver.total;
                }
            }
        }

        // Check whether we need to create a new over or just add this ball to an existing over
        const existingIndex = displayCommentaries.findIndex(dc => dc.over === over);
        if (existingIndex !== -1) {
            displayCommentaries[existingIndex].balls.push(c)
        } else {
            displayCommentaries.push({
                over: over,
                balls: [c],
                runs,
                wickets,
                total
            })
        }
    })

    if (displayCommentaries.length > 20) {
        displayCommentaries = displayCommentaries.slice(0, 20);
    }

    return (
        <div className="commentaries">
            {displayCommentaries.map((dp, index) => (
                <div className="commentary" key={index}>
                    <div className="commentary-header">
                        <div className="commentary-header-over">{ isHundred ? '' : 'Over ' + Number(dp.over)}</div>
                        <div className="commentary-header-runs">{dp.runs} runs</div>
                        <div className="commentary-header-total">{dp.total}/{dp.wickets}</div>
                    </div>
                    {dp.balls.map(({ ball, commentary }, i) => {
                        let backgroundColor = '#EEE';
                        let color = '#000';

                        if (commentary.includes('2') || commentary.includes('3')) {
                            backgroundColor = '#2188CD';
                            color = '#FFF';
                        } else if (commentary.includes('4') || commentary.includes('5')) {
                            backgroundColor = '#4BC408';
                            color = '#FFF';
                        } else if (commentary.includes('6')) {
                            backgroundColor = '#F96D33';
                            color = '#FFF';
                        } else if (commentary.includes('WICKET')) {
                            backgroundColor = '#000';
                            color = '#FFF';
                        }

                        ball = ball.toFixed(1)

                        return (
                            <div style={{ backgroundColor, color }} className="commentary-item" key={i}>
                                <span className="ball">{isHundred ? oversToBalls(ball) : ball}</span>
                                {commentary}
                            </div>
                        )})
                    }
                </div>
            ))}
        </div>
    )
}
